import { HistoricRepository } from '../../repositories/HistoricRepository';
import { UseCase } from '../UseCase';
import { Sell } from '../../models/Sell';
//import { QueryByType } from '../../constants/QueryByType';

export class GetHistoricMovementsFilteredUseCase implements UseCase<GetHistoricMovementsFilteredDto, Sell[]>{

    constructor(
        private historicRepo: HistoricRepository
    ) { }

    execute(t: GetHistoricMovementsFilteredDto): Promise<Sell[]> {
        return this.historicRepo.getHistoricMovementsFiltered(t.date, t.dateEnd,t.page, t.all);
    }

}

export class GetHistoricMovementsFilteredDto {
    constructor(
        public date: string,
        public dateEnd: string,
        public page: number,
        public all:boolean = false
    ) { }
}